export const GET_PARTNER_ID_QUERY = 'getPartnerId';
export const GET_PARTNER_LAST_SYNC_TIME ='getLastSyncTime';